exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n    ////////////////////////////////////////////////\n    //            FONT - COLOR - BACKGROUNDS MIXERS            //\n    ////////////////////////////////////////////////\n\n */\n:root {\n  --purple:#640a92;\n  --orchid:#bf4cbf;\n  --white:#fff;\n  --grey:#4a4a4a;\n  --sub-grey:#d8d8d8;\n  --dark:#1a1a1a;\n  --green:#3dadad;\n  --nvidia-green:#76b900;\n}\n.paybright {\n  text-transform: initial;\n}\n.paybright a {\n  color: #bf4cbf !important;\n}\n.paybright p {\n  margin-bottom: 0;\n}\n.paybright img {\n  display: inline;\n}", ""]);

// exports
